import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../services/api';
import type { LocationBalanceStats, DeliveryMenStats, ItemsSoldStats } from '../../types';

interface StatsState {
  locationBalanceStats: LocationBalanceStats | null;
  deliveryMenStats: DeliveryMenStats | null;
  itemsSoldStats: ItemsSoldStats | null;
}

const initialState: StatsState = {
  locationBalanceStats: null,
  deliveryMenStats: null,
  itemsSoldStats: null,
};

export const fetchLocationBalance = createAsyncThunk(
  'stats/fetchLocationBalance',
  async ({ fromDate, toDate }: { fromDate: string; toDate: string }) => {
    const response = await api.fetchLocationBalanceStats(fromDate, toDate);
    return response.data;
  }
);

export const fetchDeliveryMen = createAsyncThunk(
  'stats/fetchDeliveryMen',
  async ({ fromDate, toDate }: { fromDate: string; toDate: string }) => {
    const response = await api.fetchDeliveryMenStats(fromDate, toDate);
    return response.data;
  }
);

export const fetchItemsSold = createAsyncThunk(
  'stats/fetchItemsSold',
  async ({ fromDate, toDate }: { fromDate: string; toDate: string }) => {
    const response = await api.fetchItemsSoldStats(fromDate, toDate);
    return response.data;
  }
);

const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocationBalance.fulfilled, (state, action) => {
        state.locationBalanceStats = action.payload;
      })
      .addCase(fetchDeliveryMen.fulfilled, (state, action) => {
        state.deliveryMenStats = action.payload;
      })
      .addCase(fetchItemsSold.fulfilled, (state, action) => {
        state.itemsSoldStats = action.payload;
      });
  },
});

export default statsSlice.reducer;
